import witsScisReverse from "../../images/wits-scis-reverse.png";
import cspLogo from "../../images/csp_logo.png";
import nationalTreasuryReverse from "../../images/national-treasury-reverse.png";
import citieschairlogo from "../../images/city-chair-logo-sidebar.png";
import ufsLogoReverse from "../../images/ufs-logo-reverse.png";
import newsletter from "../../images/newsletter.png";

export default function Footer() {
  return (
    <div className="z-10">
      <div className="flex">
        <div
          style={{
            width: "25%",
            height: 5,
            backgroundColor: "#84746C",
          }}
        />
        <div
          style={{
            width: "25%",
            height: 5,
            backgroundColor: "#F0A400",
          }}
        />
        <div
          style={{
            width: "25%",
            height: 5,
            backgroundColor: "#009641",
          }}
        />
        <div
          style={{
            width: "25%",
            height: 5,
            backgroundColor: "#E53812",
          }}
        />
      </div>
      <div className="bg-gray-300 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src={ufsLogoReverse}
            alt="UFS Logo"
            style={{ height: 52, marginLeft: 26, marginRight: 26, marginTop: 5, marginBottom: 5 }}
          />
          <img
            src={citieschairlogo}
            alt="Cities Chair Logo"
            style={{ height: 52, marginRight: 34, marginTop: 5, marginBottom: 5 }}
          />
          <img
            src={nationalTreasuryReverse}
            alt="National Treasury Logo"
            style={{ height: 52, marginRight: 40, marginTop: 5, marginBottom: 5 }}
          />
          <img
            src={cspLogo}
            alt="CSP Logo"
            style={{ height: 52, marginRight: 40, marginTop: 5, marginBottom: 5 }}
          />
          <img
            src={witsScisReverse}
            alt="Wits SCIS Logo"
            style={{ height: 42, marginRight: 40, marginTop: 5, marginBottom: 5 }}
          />
        </div>
        <a
          href="https://galeboeservices.everlytic.net/public/forms/h/XhCGLpXkIeXYSR1e/NzYyZDFiOWI2N2ExOGQzNzlhZmUwMWM1YjU0MGExNWM0MGIyNzM5Yw=="
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center mr-10 group"
        >
          <div className="flex flex-col mr-3 text-right">
            <span className="font-medium text-xs relative overflow-hidden">
              <span className="relative z-10 text-white transition-colors duration-300 group-hover:text-gray-700">SEAD Newsletter</span>
              <span className="absolute inset-0 w-0 bg-gray-300 -z-0 group-hover:w-full transition-all duration-300 ease-in-out" style={{ transitionProperty: 'width' }}></span>
            </span>
            <span className="text-xs relative overflow-hidden">
              <span className="relative z-10 text-white transition-colors duration-300 group-hover:text-gray-700">Sign up here!</span>
              <span className="absolute inset-0 w-0 bg-gray-300 -z-0 group-hover:w-full transition-all duration-300 ease-in-out" style={{ transitionProperty: 'width', transitionDelay: '0.1s' }}></span>
            </span>
          </div>
          <img
            src={newsletter}
            alt="SEAD Newsletter Registration"
            style={{ height: 40 }}
          />
        </a>
      </div>
    </div>
  );
}
